/**
 * Mirror of `CheqMe.Web.Contracts.Booking.BookingReferences.BookingReferenceEntityState`.
 *
 * What kind of entity a booking reference sits on. The web app used to infer this by joining the reference onto the
 * floor-plan read and calling every miss "ad hoc" — which mislabelled a booking that had attached itself to a
 * soft-deleted table as a walk-in. Numeric, because the monolith serializes enums as their integer value.
 *
 * **Appended only** — the values ride the wire.
 */
export enum BookingReferenceEntityState {
  /** A live catalog table with a place on the floor plan; the map draws it. */
  Placed = 0,
  /** Live but with no place on the plan — a walk-in number, or a table deleted while it still carried a booking. */
  Unplaced = 1,
  /** The carrying row is soft-deleted. Pre-#205 data only; the table it names no longer exists. */
  Removed = 2
}
